import { module } from 'modujs';
import { gsap } from 'gsap';
import { TextPlugin } from "../libs/gsap/TextPlugin";

gsap.registerPlugin(TextPlugin);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

		this.$prompt = this.$('prompt');
		this.$images = this.$('image');
		this.$input = this.$('input')[0];

		this.index = 0;

		this.isLaunched = false;
    }

	ready() {
		this.next(true);
	}

	trigger(e) {

		if(e.mode == 'enter') {
			this.isLaunched = true;
			this.next(true);
		} else {
			this.isLaunched = false
		}
	}

	next(firstHit = false) {
		if(this.delayedCall != undefined) {
			this.delayedCall.kill();
		}

		this.$images.forEach((image, itemIndex) => {
			if(itemIndex == this.index) {
				image.classList.add('is-active');
			} else {
				image.classList.remove('is-active');
			}
		});

		this.$prompt.forEach((prompt, itemIndex) => {
			if(itemIndex == this.index) {
				gsap.to(prompt,{
					duration: 2,
					text: prompt.getAttribute('data-value'),
					onUpdate: () => {
						this.$input.value = `${prompt.innerText}|`;
					}
				});
			} else {
				gsap.to(prompt,{
					duration: 2,
					text: ''
				});
			}
		});

		if(this.index < this.$images.length - 1) {
			this.index++;
		} else {
			this.index = 0;
		}

		this.delayedCall = gsap.delayedCall(3,() => {
			if(this.isLaunched) {
				this.next();
			}
		});
	}
}
